import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dialog } from "primereact/dialog"
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IBenchConsultant } from "../../models/BenchConsultant";
import { Button } from "primereact/button";

interface Iprops {
    singleData: IBenchConsultant
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export interface IH1B_Assign {
    assign_ID?: number,
    consultant_ID?: number,
    sales_ID?: number,
    login_ID?: number,
    user_Name?: string,
    role_ID?: number,
    role_Name?: string
}

export const SalesManagerList = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [selectedSales, setSelectedSales] = useState<Array<IH1B_Assign>>();
    const [sM, setSM] = useState<Array<IH1B_Assign>>([]);

    const loadSm = async () => {
        const response = await Fetch("Consultant_Bench/allocate", "GET", null, `consultant_ID=${props.singleData.consultant_ID}`, null);
        if (response) {
            const data: Array<IH1B_Assign> = await response.json();
            setSM(data);
            const _data: Array<IH1B_Assign> = [];
            data.forEach(d => { if (d.assign_ID) _data.push(d); });
            setSelectedSales(_data);
        }
    }

    const footerTemplate = () => {
        return <> <Button loading={loading} className="p-button-sm my-1" label="SUBMIT" type="button" onClick={saveToDB}></Button>
            <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide}></Button></>
    }

    const saveToDB = async () => {
        if (selectedSales?.length && selectedSales.length > 0) {
            setLoading(true);
            const data: Array<IH1B_Assign> = [];
            selectedSales.forEach(s => {
                s.assign_ID = undefined;
                s.consultant_ID = props.singleData.consultant_ID;
                s.sales_ID = s.login_ID;
                data.push(s);
            });

            const response = await Fetch("Consultant_Bench/allocate", "POST", data, `consultant_ID=${props.singleData.consultant_ID}`, props.toast);

            if (response) {
                onHide();
                props.toast.current.show({ severity: 'success', detail: "Allocated Successfully.", life: 3000 });
            }
            setLoading(false);
        } else props.toast.current.show({ severity: 'error', detail: "Select Sales Manager to Allocate.", life: 3000 });
    }

    useEffect(() => {
        if (props.singleData.consultant_ID) loadSm();
    }, [props.singleData.consultant_ID]);

    const onHide = () => {
        props.hideDialog();
        setSelectedSales(undefined);
    }

    return <>
        <Dialog visible={props.open} style={{ width: '60vw' }} header="Allocate Sales Managers" footer={footerTemplate} className="p-fluid" onHide={onHide}>
            <DataTable value={sM} scrollable scrollHeight="flex" tableStyle={{ minWidth: '50rem' }}
                selectionMode='multiple' selection={selectedSales}
                onSelectionChange={(e) => {
                    const value = e.value as IH1B_Assign[];
                    setSelectedSales(value);
                }} dataKey="login_ID"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="user_Name" header="Name" />
                <Column field="role_Name" header="Role" />
            </DataTable>
        </Dialog>
    </>
}